import React from 'react'

const ArrowLeftIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='6'
    height='12'
    viewBox='0 0 14 14'
    fill='none'
    {...props}
  >
    <path
      d='M10.5 2.31437L6.17341 7L10.5 11.6856L9.16802 13.125L3.5 7L9.16802 0.875L10.5 2.31437Z'
      fill='currentColor'
    />
  </svg>
)

export default ArrowLeftIcon
